module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-proven-benefits"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "box-content"
  }, [_c('div', {
    staticClass: "box-content-inner"
  }, [_vm._m(1), _vm._v(" "), _c('hr', {
    staticClass: "frl-hr"
  }), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('hr', {
    staticClass: "frl-hr"
  }), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('hr', {
    staticClass: "frl-hr"
  }), _vm._v(" "), _vm._m(4), _vm._v(" "), _c('hr', {
    staticClass: "frl-hr"
  }), _vm._v(" "), _c('testimonials-carousel', {
    attrs: {
      "addclass": "content-slider"
    }
  }, [_c('div', {
    staticClass: "carousel-inner",
    attrs: {
      "role": "listbox"
    }
  }, [_c('div', {
    staticClass: "quote-slider-item item active"
  }, [_c('div', {
    staticClass: "content-slider-item"
  }, [_c('div', {
    staticClass: "slider-text"
  }, [_c('p', {
    staticClass: "slider-header"
  }, [_vm._v("\n                                    Engraved Brick Projects:\n                                    "), _c('br'), _vm._v("\n                                    From Concept to Completion\n                                ")]), _vm._v(" "), _c('p', {
    staticClass: "slider-paragraph"
  }, [_vm._v("\n                                    Centennial Park Monument\n                                    "), _c('br'), _vm._v("\n                                    McCall, ID\n                                ")])]), _vm._v(" "), _c('div', {
    staticClass: "slider-image"
  }, [_c('img', {
    staticClass: "img-responsive",
    attrs: {
      "src": "images/Proven-Benefits/rotatingprojects01.png",
      "alt": ""
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "quote-slider-item item"
  }, [_c('div', {
    staticClass: "content-slider-item"
  }, [_c('div', {
    staticClass: "slider-text"
  }, [_c('p', {
    staticClass: "slider-header"
  }, [_vm._v("\n                                    Engraved Brick Projects:\n                                    "), _c('br'), _vm._v("\n                                    From Concept to Completion\n                                ")]), _vm._v(" "), _c('p', {
    staticClass: "slider-paragraph"
  }, [_vm._v("\n                                    The Grove Plaza\n                                    "), _c('br'), _vm._v("\n                                    Boise, ID\n                                ")])]), _vm._v(" "), _c('div', {
    staticClass: "slider-image"
  }, [_c('img', {
    staticClass: "img-responsive",
    attrs: {
      "src": "images/Proven-Benefits/rotatingprojects02.png",
      "alt": ""
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "quote-slider-item item"
  }, [_c('div', {
    staticClass: "content-slider-item"
  }, [_c('div', {
    staticClass: "slider-text"
  }, [_c('p', {
    staticClass: "slider-header"
  }, [_vm._v("\n                                    Engraved Brick Projects:\n                                    "), _c('br'), _vm._v("\n                                    From Concept to Completion\n                                ")]), _vm._v(" "), _c('p', {
    staticClass: "slider-paragraph"
  }, [_vm._v("\n                                    Portsmouth Veterans Memorial\n                                    "), _c('br'), _vm._v("\n                                    Portsmouth, NH\n                                ")])]), _vm._v(" "), _c('div', {
    staticClass: "slider-image"
  }, [_c('img', {
    staticClass: "img-responsive",
    attrs: {
      "src": "images/Proven-Benefits/rotatingprojects03.png",
      "alt": ""
    }
  })])])])])])], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "jumbo-wrapper proven-benefits"
  }, [_c('div', {
    staticClass: "jumbo-main"
  }, [_c('div', {
    staticClass: "jumbo-content"
  }, [_c('p', {
    staticClass: "t15"
  }, [_vm._v("PROVEN BENEFITS")]), _vm._v(" "), _c('h2', {
    staticClass: "t42"
  }, [_vm._v("\n                    PERSONALIZE THE\n                    "), _c('br'), _vm._v("\n                    FUNDRAISING EXPERIENCE\n                ")]), _vm._v(" "), _c('p', {
    staticClass: "t20"
  }, [_vm._v("Heartfelt messages will be showcased for generations.")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row engraved-icons"
  }, [_c('div', {
    staticClass: "col-sm-6 col-xs-12 col-md-4 text-center"
  }, [_c('div', {
    staticClass: "icon-box"
  }, [_c('img', {
    attrs: {
      "src": "images/Proven-Benefits/engageicon.png",
      "alt": ""
    }
  })]), _vm._v(" "), _c('h2', [_vm._v("STRENGTHEN CONNECTIONS")]), _vm._v(" "), _c('p', [_vm._v("Showcase your community's support")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6 col-xs-12 col-md-4 text-center"
  }, [_c('div', {
    staticClass: "icon-box"
  }, [_c('img', {
    attrs: {
      "src": "images/Proven-Benefits/raisefundsicon.png",
      "alt": ""
    }
  })]), _vm._v(" "), _c('h2', [_vm._v("RAISE FUNDS")]), _vm._v(" "), _c('p', [_vm._v("Meet key fundraising objectives")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6 col-xs-12 col-md-4 text-center"
  }, [_c('div', {
    staticClass: "icon-box"
  }, [_c('img', {
    attrs: {
      "src": "images/Proven-Benefits/activateicon.png",
      "alt": ""
    }
  })]), _vm._v(" "), _c('h2', [_vm._v("BEAUTIFY ANY SPACE")]), _vm._v(" "), _c('p', [_vm._v("Add visual impact that lasts")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "body-area"
  }, [_c('div', {
    staticClass: "body-area-left"
  }, [_c('h6', {
    staticClass: "body-area-headline"
  }, [_vm._v("\n                        A FUNDRAISING CONCEPT\n                        THAT GIVES DONORS AT ALL\n                        LEVELS A TANGIBLE WAY TO PUT\n                        THEIR NAME ON A PROJECT.\n                    ")]), _vm._v(" "), _c('p', [_vm._v("\n                        Offer your donors a brick or tile they can\n                        customize to be placed at your facility or\n                        selected location. The permanent showcase\n                        stregthens the connection with your donors -\n                        past, present, and future.\n                    ")])]), _vm._v(" "), _c('div', {
    staticClass: "body-area-right"
  }, [_c('img', {
    staticClass: "img-responsive",
    attrs: {
      "width": "443",
      "height": "362",
      "src": "images/Proven-Benefits/engravedbrickprojects01.png",
      "alt": ""
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "body-area"
  }, [_c('div', {
    staticClass: "body-area-left"
  }, [_c('img', {
    staticClass: "img-responsive",
    attrs: {
      "width": "443",
      "height": "362",
      "src": "images/Proven-Benefits/engravedbrickprojects02.png",
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "body-area-right"
  }, [_c('h6', {
    staticClass: "body-area-headline"
  }, [_vm._v("\n                        NOW IS A GREAT TIME TO"), _c('br'), _vm._v("\n                        START YOUR ENGRAVED"), _c('br'), _vm._v("\n                        BRICK FUNDRAISER.\n                    ")]), _vm._v(" "), _c('p', [_vm._v("\n                        Whether you have a specific fundraising goal,\n                        want to celebrate a historic moment or\n                        anniversary, or just want to recognize donors,\n                        it’s always a good time!\n                    ")]), _vm._v(" "), _c('ul', {
    staticClass: "body-area-list"
  }, [_c('li', [_c('span', [_vm._v("New Facility Construction or Renovations")])]), _vm._v(" "), _c('li', [_c('span', [_vm._v("Activate Underutilized Areas")])]), _vm._v(" "), _c('li', [_c('span', [_vm._v("Create a Gathering Space")])]), _vm._v(" "), _c('li', [_c('span', [_vm._v("Commemorate Town History or Anniversary")])]), _vm._v(" "), _c('li', [_c('span', [_vm._v("Honor Military Veterans")])]), _vm._v(" "), _c('li', [_c('span', [_vm._v("Dedicate a Project or Space")])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "body-area"
  }, [_c('div', {
    staticClass: "body-area-left"
  }, [_c('h6', {
    staticClass: "body-area-headline"
  }, [_vm._v("\n                        TRANSFORM ANY LOCATION"), _c('br'), _vm._v("\n                        INTO A DESTINATION,"), _c('br'), _vm._v("\n                        SHOWCASING PERSONAL"), _c('br'), _vm._v("\n                        MESSAGES FROM DONORS.\n                    ")]), _vm._v(" "), _c('p', [_vm._v("\n                        Showcase a central location or an underutilized\n                        space. Engraved bricks will create a space for\n                        your donors and others to gather, connect,\n                        photograph & enjoy!\n                    ")]), _vm._v(" "), _c('ul', {
    staticClass: "body-area-list list2col"
  }, [_c('li', [_c('span', [_vm._v("Entrances")])]), _vm._v(" "), _c('li', [_c('span', [_vm._v("Sidewalks")])]), _vm._v(" "), _c('li', [_c('span', [_vm._v("Walkways")])]), _vm._v(" "), _c('li', [_c('span', [_vm._v("Gardens")])]), _vm._v(" "), _c('li', [_c('span', [_vm._v("Plazas")])]), _vm._v(" "), _c('li', [_c('span', [_vm._v("Indoor Walls")])]), _vm._v(" "), _c('li', [_c('span', [_vm._v("Outdoor Walls")])]), _vm._v(" "), _c('li', [_c('span', [_vm._v("Underutilized Areas")])])])]), _vm._v(" "), _c('div', {
    staticClass: "body-area-right"
  }, [_c('img', {
    staticClass: "img-responsive",
    attrs: {
      "width": "443",
      "height": "362",
      "src": "images/Proven-Benefits/engravedbrickprojects03.png",
      "alt": ""
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-507db65c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/projects/ProvenBenefits.vue
// module id = YWV/
// module chunks = 1